module.exports = __webpack_public_path__ + "img/cost-serve.806839be.png";